import axios from 'axios';
import * as THREE from "three";
import React, { useEffect } from 'react'

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography'
import RadioGroup from '@material-ui/core/RadioGroup'
import TextField from '@material-ui/core/TextField';
import SideStyle from '../style/sideStyle';
import { GreyRadio } from '../style/customUI';
import Control from '../store/control';
import Param from '../store/param';
// import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
// import { POLLING_INTERVAL1 } from '../store/global';
import { STLExporter } from 'three/addons/exporters/STLExporter.js';
import { Scene } from "three";
import {toast} from 'react-toastify';
import { AddIcon } from './formUtil';

const FormOutput = () => {
  const style           = SideStyle();
  const outputBk           = Param.Get("outputBk");
  const setParam        = Param.Get("setParam");
  const SetCameraBottom = Control.Get("SetCameraBottom");
  const SetCameraFree = Control.Get("SetCameraFree");
  const setControl      = Control.Get("setControl");

  const showMirror = Control.Get('showMirror');
  const meshSocketThick = Control.Get("meshSocketThick");
  const meshSocketOutput = Control.Get("meshSocketOutput");

  const onApply = () => {
    setParam(s => {s.outputBk.step = 1});
  };

  const onClear = () => {
    setControl(s => {s.meshSocketOutput = null});
    setParam(s => {s.outputBk.step = 0});
  };

  function save( blob, filename ) {
    const link = document.createElement( 'a' );
    link.style.display = 'none';
    document.body.appendChild( link );
    
    link.href = URL.createObjectURL( blob );
    link.download = filename;
    link.click();
  }

  function saveArrayBuffer( buffer, filename ) {
    save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
  }


  const handleExport = (outputGeom) => {
    console.log(outputGeom)
    if (outputGeom == null) {
      toast.error('No mesh to export.')
      return;
    }

    if ( showMirror == 1 ) {
      var mS = (new THREE.Matrix4()).identity();
      //set -1 to the corresponding axis
      mS.elements[0] = -1;
      mS.elements[10] = -1;
      outputGeom.applyMatrix4(mS);
    }

    const scene = new THREE.Scene();
    const saveGeom = outputGeom.clone();
    const material = new THREE.MeshStandardMaterial( { color: 0x000000 } );
    saveGeom.rotateX(Math.PI/2);
    let mesh = new THREE.Mesh(saveGeom, material);
    if ( showMirror == 1 ) {
      // mesh.scale.x = -1; // doesn't work
    }

    scene.add(mesh.clone());

    const exporter = new STLExporter();
    const result = exporter.parse( scene, { binary: true } );

    saveArrayBuffer( result, 'socket.stl' );
  }

  const handleValue = (e) => {
    setParam(s => {s.outputBk[e.target.name] = e.target.value});
  };

  function getDisabled(step){
    return (outputBk.step == step) ? false : true;
  }

  useEffect(() => {
     SetCameraFree();
     setControl(s => {s.flgLegClickable = false, s.flgSocketClickable = true});
  });

  
  useEffect(() => {
    setParam(s => {s.instructionText = "Click on the position to merge a conector, and push [Merge]"});
  });

  return (
    <div className={style.outside}>
      {/* Whole Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Top edge reinforcement</Grid>
      </Grid>


      <Grid container spacing={1} alignItems='center'>
        <TextField
          id='filled-number'
          name='reinforcementTopEdgeWidth'
          label='Reinforcement width'
          type='number'
          defaultValue={outputBk.reinforcementTopEdgeWidth}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext=''/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0, 
            max:500,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='reinforcementTopEdgeThickness'
          label='Reinforcement thickness'
          type='number'
          defaultValue={outputBk.reinforcementTopEdgeThickness}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext=''/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0, 
            max:50,
            step:1
          }}
        />
      </Grid>
      

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Weaknest area reinforcement</Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center'>
        <TextField
          id='filled-number'
          name='reinforcementWeaknestAreaWidth'
          label='Reinforcement width'
          type='number'
          defaultValue={outputBk.reinforcementWeaknestAreaWidth}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext=''/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0, 
            max:50,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='reinforcementWeaknestAreaThickness'
          label='Reinforcement thickness'
          type='number'
          defaultValue={outputBk.reinforcementWeaknestAreaThickness}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext=''/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0, 
            max:50,
            step:1
          }}
        />
      </Grid>

      

      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Button className={(getDisabled(0)) ? style.buttonDisable : style.button} onClick={onApply} disabled={getDisabled(0)} size='small' >Apply</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={(getDisabled(1)) ? style.buttonDisable : style.button} onClick={onClear} disabled={getDisabled(1)} size='small' >Clear Socket</Button>
        </Grid>
      </Grid>

      {/*  Output button */}
      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <Button
          component='label'
          className={style.button}
          onClick={()=>handleExport(meshSocketOutput ? meshSocketOutput.geometry : meshSocketThick.geometry)}
          size='small' >
          Export STL
        </Button>
      </Grid>
    </div>
  );
}
export default FormOutput;
